import React, { Component } from 'react'
import { reaction } from 'mobx'
import { observer, inject, Provider } from 'mobx-react'
import uniqueId from 'lodash/uniqueId'

import Searches from '../stores/searches'
import Leads from '../stores/leads'
import RecommendedSearches from '../stores/recommended_searches'
import RecommendedListings from '../stores/recommended_listings'
import Hotsheets from '../stores/hotsheets'
import Messages from '../stores/messages'

function initStores(website) {
  return {
    messages: new Messages({ website }),
    hotsheets: new Hotsheets({ website }),
    recommended_searches: new RecommendedSearches({ website }),
    recommended_listings: new RecommendedListings({ website }),
    searches: new Searches({ website }),
    leads: new Leads({ website })
  }
}

@inject(['websites'])
@observer
export default class WebsiteStoresProvider extends Component {
  state = {}

  componentDidMount() {
    this.disposeWebsiteReactions = reaction(
      // Predicate: Whenever the current website changes
      () => this.props.websites.current,

      // Action: Create new stores for website
      website => this.setState({ stores: initStores(website), storesId: uniqueId('') }),

      // Options:
      { delay: 1 }
    )
  }

  componentWillUnmount() {
    this.disposeWebsiteReactions()
  }

  render() {
    const { children } = this.props
    const { stores, storesId } = this.state

    if (!stores) return null

    return (
      <Provider {...stores} key={storesId}>
        {children}
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// client/components/WebsiteStoresProvider.js